export const SPEED_OF_SOUND = 343;

export const typeColors = {
  axial: "#E8C547",
  tangential: "#4ECDC4",
  oblique: "#95E06C",
};

export const typeLabels = {
  axial: "Axial",
  tangential: "Tangential",
  oblique: "Oblique",
};

// Structural modal analysis — mode type colors and labels
export const structuralTypeColors = {
  flexuralX:    "#E8C547",   // gold — bending in X-Z plane
  flexuralY:    "#4ECDC4",   // cyan — bending in Y-Z plane
  longitudinal: "#95E06C",   // green — axial stretch along Z
  torsional:    "#C77DFF",   // purple — twist about Z axis
  mixed:        "#8A8F98",   // gray — no single dominant pattern
  rigid:        "#5A5F68",   // dim gray — rigid body modes (≈0 Hz)
};

export const structuralTypeLabels = {
  flexuralX:    "Flexural X",
  flexuralY:    "Flexural Y",
  longitudinal: "Longitudinal",
  torsional:    "Torsional",
  mixed:        "Mixed",
  rigid:        "Rigid Body",
};

// Default material presets for structural analysis
export const materialPresets = {
  steel: { name: "Steel", density: 7850, youngsModulus: 200e9, poissonsRatio: 0.3 },
  aluminum: { name: "Aluminum", density: 2700, youngsModulus: 69e9, poissonsRatio: 0.33 },
  titanium: { name: "Titanium", density: 4500, youngsModulus: 116e9, poissonsRatio: 0.34 },
  copper: { name: "Copper", density: 8960, youngsModulus: 117e9, poissonsRatio: 0.34 },
  concrete: { name: "Concrete", density: 2400, youngsModulus: 30e9, poissonsRatio: 0.2 },
  wood_oak: { name: "Oak Wood", density: 700, youngsModulus: 12e9, poissonsRatio: 0.35 },
  abs_plastic: { name: "ABS Plastic", density: 1050, youngsModulus: 2.3e9, poissonsRatio: 0.35 },
};
